import { repeatCallEntityName } from '../../../../backend/config/classifiers';
import { buildValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
export function buildRepeatCallValueProvider(appName) {
    return buildValueProvider(appName, repeatCallEntityName, 'Repeat Call', false, repeatCallEntityName, (client) => {
        return client
            .storageList({ filter: [{ column: 'status', op: '=', value: 'active' }], orderBy: [{ column: 'value' }] })
            .then((result) => result.rows.map((row) => ({ value: row.columns.value, label: row.columns.name })));
    });
}
